import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */

const apiCaller = getApiInstance('gitlab');

function getAllProjects() {
    return (dispatch, getState) => {
        const groupId = getState().environments.fhepool.gitlabApi.get('groupId');
        return apiCaller
            .call(api.getAllProjects(groupId))
            .then(({ data }) => {
                let projects = {};
                data.forEach(({ id, name }) => {
                    projects[id] = { name };
                });
                dispatch({
                    type: 'FHEPOOL_GIT__SET_PROJECTS',
                    projects
                });
                return data;
            })
            .catch(error => {
                Logger.error('dataActions: getAllFHEPOOL_GIT - ', error);
                throw error;
            });
    };
}
function getProject(projectId) {
    return dispatch => {
        return apiCaller
            .call(api.getProject(projectId))
            .then(({ data }) => {
                if (data) {
                    const { id, name } = data;
                    const project = { [id]: { name } };
                    dispatch({
                        type: 'FHEPOOL_GIT__SET_PROJECT',
                        project
                    });
                    return data;
                } else throw new Error('project_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: getProject - ', error);
                throw error;
            });
    };
}

export { getAllProjects, getProject };



// WEBPACK FOOTER //
// ./environments/fhepool/data/Projects/actions.js